module.exports = __webpack_public_path__ + "static/img/16.47584d5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/eng/16.png
// module id = u8yN
// module chunks = 0